import type {
  AuthUser,
  ChangePasswordInput,
  LoginInput,
  LoginResponse,
} from "@/features/auth/types";
import { api } from "@/lib/axios";

export const authApi = {
  login: (input: LoginInput) =>
    api.post<LoginResponse>("/auth/login", input).then((res) => res.data),

  logout: (refreshToken: string) =>
    api.post<void>("/auth/logout", { refreshToken }).then((res) => res.data),

  /** Refetches the current user's own profile + fieldVisibilityKeys — called on every app boot. */
  me: () => api.get<AuthUser>("/auth/me").then((res) => res.data),

  /** Self-service password change — the backend revokes every other session on success, so the
   * caller should log the user out locally right after (see useChangePasswordMutation). */
  changePassword: (input: ChangePasswordInput) =>
    api.patch<void>("/auth/change-password", input).then((res) => res.data),
};
